import { render } from "./eventCardList.vue?vue&type=template&id=93724170&scoped=true"
import script from "./eventCardList.vue?vue&type=script&lang=js"
export * from "./eventCardList.vue?vue&type=script&lang=js"

import "./eventCardList.vue?vue&type=style&index=0&id=93724170&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93724170"]])

export default __exports__